export const taiKhoanQuy = {
  sections: {
    list: { title: 'Cash Account Management' },
  },
  titles: {
    add: 'Add Cash Account',
    edit: 'Edit Cash Account',
    // P13 (code-review 5.3): title dialog confirm delete — spec AC-3 literal.
    xoaConfirm: 'Delete Cash Account',
  },
  columns: {
    ten: 'Account Name',
    loai: 'Type',
    chiNhanh: 'Branch',
    nganHang: 'Bank',
    soDuBanDau: 'Opening Balance',
    soDuHienTai: 'Current Balance',
    trangThai: 'Status',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    thaoTac: 'Actions',
  },
  filter: {
    searchPlaceholder: 'Search by name, bank name, account no...',
    textDetailTitle: 'Detailed filter',
  },
  filters: {
    hintSection: 'Cash Account Filters',
    hintBody: 'Filter by type, status and branch',
    chiNhanhAll: 'All branches',
    chiNhanhSearch: 'Search branch',
    chiNhanhEmpty: 'No branches',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  filterSection: {
    loai: 'Type',
    trangThai: 'Status',
    tatCa: 'All',
  },
  loai: {
    TIEN_MAT: 'Cash Fund',
    NGAN_HANG: 'Bank Account',
  },
  trangThai: {
    DANG_HOAT_DONG: 'Active',
    NGUNG_HOAT_DONG: 'Inactive',
  },
  actions: {
    them: 'Add Cash Account',
    sua: 'Edit',
    xoa: 'Delete',
    kichHoat: 'Activate',
    ngungHoatDong: 'Deactivate',
    luu: 'Save',
  },
  messages: {
    noData: 'No cash accounts yet.',
    saveSuccess: 'Cash account saved.',
    saveError: 'Unable to save cash account.',
    deleteSuccess: 'Cash account deleted.',
    deleteConfirm: 'Delete cash account {ten}? This action cannot be undone.',
    coPhieuThamChieu: 'This account is referenced by vouchers. You can only deactivate it.',
    statusChanged: 'Cash account status updated.',
    xungDotVersion: 'This cash account was modified by someone else. Please reload.',
    soTaiKhoanTrung: 'This bank account number already exists in the branch.',
    tenTrung: 'This cash fund name already exists in the branch.',
    // P14 (code-review 5.3): V-013 explicit branch — NGAN_HANG missing required info.
    nganHangThieuThongTin: 'Bank account must include both bank name and account number.',
    listSummary: 'Total {count} accounts',
    loadError: 'Unable to load cash account list.',
  },
  form: {
    ten: 'Account Name',
    loai: 'Account Type',
    nganHangTen: 'Bank Name',
    nganHangSoTaiKhoan: 'Account Number',
    nganHangChiNhanh: 'Bank Branch',
    chiNhanh: 'Branch',
    soDuBanDau: 'Opening Balance',
    dangHoatDong: 'Active Status',
    soDuHienTai: 'Current Balance',
    dangHoatDongOn: 'Active',
    dangHoatDongOff: 'Inactive',
  },
  validation: {
    tenRequired: 'Account name is required',
    tenMinLength: 'Name must be at least 3 characters',
    tenMaxLength: 'Name must be at most 100 characters',
    nganHangTenRequired: 'Bank name is required when Bank Account is selected',
    soTaiKhoanInvalid: 'Account number must be 6-20 digits',
    nganHangTenMaxLength: 'Bank name must be at most 100 characters',
    nganHangChiNhanhMaxLength: 'Bank branch must be at most 100 characters',
    soDuBanDauRequired: 'Opening balance is required',
    soDuBanDauInvalid: 'Opening balance must be a non-negative number',
    soDuBanDauQuaLon: 'Opening balance exceeds the allowed limit',
    chuaXacDinhChiNhanh: 'Branch not identified. Please log in again.',
    chiNhanhRequired: 'Please select at least 1 branch.',
  },
  placeholders: {
    formTitle: 'Enter account name...',
    formBody: '',
    soDuBanDau: '0',
    nganHangSoTaiKhoan: 'Enter 6-20 digits',
  },
  detailTabs: {
    phieuThu: 'Receipts',
    phieuChi: 'Payments',
  },
  expand: {
    rowClickExpand: 'Click a row to show or hide receipts and payments',
    noPhieuThu: 'No receipts on this cash account yet.',
    noPhieuChi: 'No payments on this cash account yet.',
    loadError: 'Unable to load voucher list.',
    retry: 'Retry',
    viewAll: 'View all',
    count: '{count} vouchers',
  },
}
